/*
* We remove the unnecessary redirect from http:// to https:/ for images on the VERCEL server
*/
export default defineNuxtPlugin(() => {
  const image = useImage()
  const originalGetImage = image.getImage
  image.getImage = (options) => {
    if (typeof options.src === 'string' && options.src.startsWith('https://')) {
      options.src = options.src?.replace(/^https:\/\//, '')
    }
    return originalGetImage(options)
  }
})